module.exports = [{"label":"English","value":"en"},{"label":"Türkçe","value":"tr"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/languages.json
// module id = 571
// module chunks = 0